export default __webpack_public_path__ + "static/media/gear.b767ad2b.svg";